import React from "react";
import { OnGetJson, GetCorServicei, genURL } from '../_getjson';
import axios from 'axios'
import Backdrop from './../Components/CustomBackdrop/Barckdrop'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
require('./../_css/PopUpOther.css');
export default class PopUpBankcontactsub extends React.Component {
    constructor(props) {
        super(props);
        this.Search = React.createRef();
        this.state = {

        }
    }

    Get_Expcode = (event) => {
        var dataArray = [];
        var url = "CSSITE/Name?name=" + this.Search.current.value + "&user=" + localStorage.getItem("Username");
        GetCorServicei(url)
            .then(res => {
                var data = res.data;
                if (data.length > 0) {
                    for (let i = 0; i < data.length; i++) {
                        dataArray[i] = {
                            number: i + 1,
                            code: data[i].CODE,
                            text: data[i].MYNAMETH
                        };
                    }
                }
            })
            .then(_ => {
                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            });
    }

    Get_Deposit = (event) => {
        var dataArray = [];
        var Url = "";
        if (event === "Deposit") {
            var Expcode = this.Search.current.value;
            Url = "CSINCOME/NAMETH?tablename=" + this.props.from + "&name=" + Expcode;
        } else if (event.key === "Enter") {
            var Expcode = (event.target.value);
            Url = "CSINCOME/NAMETH?tablename=" + this.props.from + "&name=" + Expcode;
        } else {
            return //--------------- Exit เมื่อไม่เข้าเงือนไขไหนเลย
        }
        GetCorServicei(Url, "iconsearch").then(res => {
            if (res.data.length >= 1) {
                for (let i = 0; i < res.data.length; i++) {
                    dataArray[i] = {
                        code: res.data[i].CODE,
                        text: res.data[i].MYNAMETH
                    }
                }
                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            }
        });
    }

    componentDidMount() {
        this.setState({ openBackdrop: true })
        var dataArray = [];
        var url = "CSBANKCASHIN/GetBookno?";
        console.log(genURL(url));
        axios.get(genURL(url), { timeout: 60000 }).then(async res => {
            var col = res.data
            for (let i = 0; i < col.length; i++) {
                dataArray[i] = {
                    number: i + 1,
                    T_Bank: col[i].BANKNAME,
                    T_Branch: col[i].BANKBRANCH,
                    T_Genre: col[i].BOOKTYPE,
                    T_Bookno: col[i].BOOKNO,
                    T_BOOKNAME: col[i].BOOKNAME,
                }
            }
            this.setState({ openBackdrop: false })
            await this.setState({ rows: dataArray })
        }).catch(error => {
            console.log(error);
            this.setState({ openBackdrop: false })
        });
    }
    onSelectRow = (data) => {
        this.props.closePopup();
        this.props.Get_PopUpBankcontactsub(data);
    }
    render() {
        return (
            <div className='popup'  >
                <Backdrop open={this.state.openBackdrop} />
                <div className='popup_inner '>
                    {this.props.Data}
                    <div class="PopUpOtherDivH" align="left">
                        <div class="PopUpOtherDivH1"><i class="fas fa-search" > เลือกรายการ-CSBANKCONTACTSUB </i> </div>
                        <div class="PopUpOtherDivH2"><i class="fas fa-times" onClick={this.props.closePopup}></i></div>
                    </div>
                    <div class="panel-body divTable" align="right">
                        <div>
                            <BootstrapTable
                                data={this.state.rows}
                                options={{
                                    onRowClick: this.onSelectRow,
                                    noDataText: "ไม่พบข้อมูลที่ค้นหา",
                                }}
                                height="750"
                                hover condensed search>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="30" dataField='number' isKey> </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='T_Bank'> ธนาคาร </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='T_Branch' > สาขา </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='T_Genre' > ประเภท </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='T_Bookno' > เลขที่บัญชี </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='T_BOOKNAME' hidden>  </TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}